import { useEffect, useState } from 'react';
import { useUIStore } from '../../stores/uiStore';

// TopProgressBar — a thin 2px indeterminate bar pinned to the top of
// the viewport that only appears once a request has been in-flight
// for longer than SHOW_DELAY_MS. Requests that resolve faster never
// trigger the bar, which eliminates the "flash on every refresh"
// problem the old full-screen overlay caused on dashboard and
// monitoring pages with aggressive polling.
//
// Background polls opt out entirely by passing showLoading: false
// (see services/api.ts). Everything else funnels through this bar.
const SHOW_DELAY_MS = 350;
const MIN_VISIBLE_MS = 250;

const LoadingOverlay = () => {
    const isLoading = useUIStore((s) => s.isLoading);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (isLoading) {
            // Delay showing to avoid flashing on fast responses
            const showTimer = window.setTimeout(() => setVisible(true), SHOW_DELAY_MS);
            return () => window.clearTimeout(showTimer);
        }

        // Keep the bar visible a minimum duration once shown so a
        // 50ms blink doesn't look broken
        if (visible) {
            const hideTimer = window.setTimeout(() => setVisible(false), MIN_VISIBLE_MS);
            return () => window.clearTimeout(hideTimer);
        }
        return undefined;
    }, [isLoading, visible]);

    if (!visible) return null;

    return (
        <div
            className="fixed top-0 left-0 right-0 z-[9999] h-[2px] pointer-events-none overflow-hidden"
            role="progressbar"
            aria-label="Loading"
        >
            <div className="vsm-topbar-progress h-full" />
        </div>
    );
};

export default LoadingOverlay;
